import FormDrawer from "../common/form-drawer--new";

const ResetFaceIdModal = ({isOpen, setIsOpen, onProceed, loading, user}) => {
	
	return (
		<FormDrawer className="z-50" display="center" size="sm" isOpen={isOpen} setIsOpen={() => {}}>
			<div className="p-5 max-w-sm">
				<h1 className="lg:text-lg font-semibold">Reset Face and ID Verification</h1>
				
				<div className="form-group mt-6 mb-10">
					<label>
						Are you sure you want to reset face and ID verification for <span className="font-semibold capitalize"> {user?.firstName} {user?.lastName}?</span>
					</label>
				</div>
				
				<div className="flex items-center justify-center lg:flex-row">
					
					<button
						type="button"
						onClick={() => setIsOpen(false)}
						className="btn btn-md border border-ep-primary-500 text-ep-primary-500 w-full lg:w-2/4 focus:ring-0 mr-4"
						disabled={loading}>
						Cancel
					</button>
					
					<button
						disabled={loading}
						type="button" 
						onClick={onProceed}
						className="btn btn-md border bg-ep-primary text-white w-full lg:w-2/4 focus:ring-0">
						{loading ? "Submitting..." : "Yes"}
					</button>
				</div>
			</div>
		</FormDrawer>
	)
}

export default ResetFaceIdModal